import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["enableAutoResize", "maxHeight", "initialHeight", "value", "onChange", "onCompositionStart", "onCompositionEnd"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useRef, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import { Input } from 'antd';
import { jsx as _jsx } from "react/jsx-runtime";
var StyledTextArea = styled(Input.TextArea).withConfig({
  displayName: "autogrowing-textarea__StyledTextArea",
  componentId: "sc-f5epuk-0"
})(["resize:none !important;overflow:hidden !important;max-height:350px !important;box-sizing:border-box !important;border:none !important;&.scroll-enabled{overflow-y:auto !important;}&:hover,&:focus{border:none !important;outline:none !important;box-shadow:none !important;}"]);
export var AutoGrowingTextarea = function AutoGrowingTextarea(_ref) {
  var _ref$enableAutoResize = _ref.enableAutoResize,
      enableAutoResize = _ref$enableAutoResize === void 0 ? true : _ref$enableAutoResize,
      _ref$maxHeight = _ref.maxHeight,
      maxHeight = _ref$maxHeight === void 0 ? 350 : _ref$maxHeight,
      _ref$initialHeight = _ref.initialHeight,
      initialHeight = _ref$initialHeight === void 0 ? 64 : _ref$initialHeight,
      value = _ref.value,
      onChange = _ref.onChange,
      onCompositionStart = _ref.onCompositionStart,
      onCompositionEnd = _ref.onCompositionEnd,
      props = _objectWithoutProperties(_ref, _excluded);

  var textAreaRef = useRef(null);
  var isComposing = useRef(false);
  var adjustHeight = useCallback(function () {
    if (!enableAutoResize || !textAreaRef.current) {
      return;
    }

    var textArea = textAreaRef.current.resizableTextArea.textArea;

    if (!textArea) {
      return;
    } // Reset height to 0px to get accurate scrollHeight without flexbox stretching interference


    textArea.style.height = '0px'; // Get the scroll height

    var scrollHeight = textArea.scrollHeight; // Calculate new height, overriding to initialHeight when the textarea is empty

    var newHeight = !value ? initialHeight : Math.min(Math.max(scrollHeight, initialHeight), maxHeight); // Apply new height

    textArea.style.height = "".concat(newHeight, "px"); // Toggle overflow based on whether content exceeds max height

    var shouldScroll = scrollHeight > maxHeight;
    textArea.classList.toggle('scroll-enabled', shouldScroll);
  }, [enableAutoResize, maxHeight, initialHeight, value]); // Handle input changes

  var handleChange = useCallback(function (e) {
    onChange === null || onChange === void 0 ? void 0 : onChange(e); // Don't resize during IME composition

    if (!isComposing.current) {
      // Use setTimeout to ensure DOM is updated
      setTimeout(adjustHeight, 0);
    }
  }, [onChange, adjustHeight]); // Handle composition events for IME support

  var handleCompositionStart = useCallback(function (e) {
    isComposing.current = true;
    onCompositionStart === null || onCompositionStart === void 0 ? void 0 : onCompositionStart(e);
  }, [onCompositionStart]);
  var handleCompositionEnd = useCallback(function (e) {
    isComposing.current = false;
    onCompositionEnd === null || onCompositionEnd === void 0 ? void 0 : onCompositionEnd(e); // Adjust height after composition ends

    setTimeout(adjustHeight, 0);
  }, [onCompositionEnd, adjustHeight]); // Initialize height and handle value changes

  useEffect(function () {
    if (enableAutoResize) {
      adjustHeight();
    }
  }, [value, enableAutoResize, adjustHeight]); // Handle window resize

  useEffect(function () {
    if (!enableAutoResize) return;

    var handleResize = function handleResize() {
      adjustHeight();
    };

    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, [enableAutoResize, adjustHeight]); // If auto-resize is disabled, use original autoSize behavior

  if (!enableAutoResize) {
    return /*#__PURE__*/_jsx(Input.TextArea, _objectSpread({
      value: value,
      onChange: onChange,
      onCompositionStart: onCompositionStart,
      onCompositionEnd: onCompositionEnd,
      autoSize: {
        minRows: 1,
        maxRows: 10
      }
    }, props));
  }

  return /*#__PURE__*/_jsx(StyledTextArea, _objectSpread({
    ref: textAreaRef,
    value: value,
    onChange: handleChange,
    onCompositionStart: handleCompositionStart,
    onCompositionEnd: handleCompositionEnd
  }, props));
};